import 'core-js/features/array/includes';
import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/array/from';
import 'core-js/features/array/every';
import 'core-js/features/array/some';
import 'core-js/features/array/fill';
import 'core-js/features/object/assign';
import 'core-js/features/object/values';
import 'core-js/features/object/entries';
// set, map, raf는 react를 위한 polyfill (https://reactjs.org/docs/javascript-environment-requirements.html)
import 'core-js/features/set';
import 'core-js/features/map';
import 'raf/polyfill';
import 'core-js/features/string/starts-with';
import 'core-js/features/string/ends-with';
import 'core-js/features/string/pad-start';
import 'core-js/features/string/includes';
import 'core-js/features/promise/finally';
import 'core-js/features/dom-collections/for-each'; // for IE11
import 'intersection-observer';
import 'custom-event-polyfill';
// 참고 링크: https://gist.github.com/paullewis/55efe5d6f05434a96c36
window.requestIdleCallback =
  window.requestIdleCallback ||
  function (
    cb: (param: {didTimeout: boolean; timeRemaining: () => number}) => void
  ) {
    return setTimeout(() => {
      const start = Date.now();
      cb({
        didTimeout: false,
        timeRemaining: () => Math.max(0, 50 - (Date.now() - start)),
      });
    }, 1);
  };
window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function (id: number) {
    clearTimeout(id);
  };

// 참고 링크: https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#polyfill
if (typeof Element !== 'undefined') {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      (Element.prototype as any).msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
  }

  if (!Element.prototype.closest) {
    Element.prototype.closest = function (s: string) {
      let el = this; // eslint-disable-line @typescript-eslint/no-this-alias

      do {
        if (Element.prototype.matches.call(el, s)) return el;
        el = (el.parentElement || el.parentNode) as Element;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }
}

// 참로 링크: https://developer.mozilla.org/en-US/docs/Web/API/TextEncoder
if (typeof TextEncoder === 'undefined') {
  (window as any).TextEncoder = function TextEncoder() {};
  (window as any).TextEncoder.prototype.encode = function encode(str: string) {
    'use strict';
    const Len = str.length;
    let resPos = -1;
    // The Uint8Array's length must be at least 3x the length of the string because an invalid UTF-16
    //  takes up the equivelent space of 3 UTF-8 characters to encode it properly. However, Array's
    //  have an auto expanding length and 1.5x should be just the right balance for most uses.
    const resArr =
      typeof Uint8Array === 'undefined'
        ? new Array(Len * 1.5)
        : new Uint8Array(Len * 3);
    for (let point = 0, nextcode = 0, i = 0; i !== Len; ) {
      (point = str.charCodeAt(i)), (i += 1);
      if (point >= 0xd800 && point <= 0xdbff) {
        if (i === Len) {
          resArr[(resPos += 1)] = 0xef;
          resArr[(resPos += 1)] = 0xbf;
          resArr[(resPos += 1)] = 0xbd;
          break;
        }
        // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        nextcode = str.charCodeAt(i);
        if (nextcode >= 0xdc00 && nextcode <= 0xdfff) {
          point = (point - 0xd800) * 0x400 + nextcode - 0xdc00 + 0x10000;
          i += 1;
          if (point > 0xffff) {
            resArr[(resPos += 1)] = (0x1e << 3) | (point >>> 18);
            resArr[(resPos += 1)] = (0x2 << 6) | ((point >>> 12) & 0x3f);
            resArr[(resPos += 1)] = (0x2 << 6) | ((point >>> 6) & 0x3f);
            resArr[(resPos += 1)] = (0x2 << 6) | (point & 0x3f);
            continue;
          }
        } else {
          resArr[(resPos += 1)] = 0xef;
          resArr[(resPos += 1)] = 0xbf;
          resArr[(resPos += 1)] = 0xbd;
          continue;
        }
      }
      if (point <= 0x007f) {
        resArr[(resPos += 1)] = (0x0 << 7) | point;
      } else if (point <= 0x07ff) {
        resArr[(resPos += 1)] = (0x6 << 5) | (point >>> 6);
        resArr[(resPos += 1)] = (0x2 << 6) | (point & 0x3f);
      } else {
        resArr[(resPos += 1)] = (0xe << 4) | (point >>> 12);
        resArr[(resPos += 1)] = (0x2 << 6) | ((point >>> 6) & 0x3f);
        resArr[(resPos += 1)] = (0x2 << 6) | (point & 0x3f);
      }
    }
    if (typeof Uint8Array !== 'undefined')
      return (resArr as any).subarray(0, resPos + 1);
    // else // IE 6-9
    (resArr as any).length = resPos + 1; // trim off extra weight
    return resArr;
  };
  (window as any).TextEncoder.prototype.toString = function () {
    return '[object TextEncoder]';
  };
  try {
    // Object.defineProperty only works on DOM prototypes in IE8
    Object.defineProperty((window as any).TextEncoder.prototype, 'encoding', {
      get() {
        if (Object.prototype.isPrototypeOf.call(TextEncoder.prototype, this))
          return 'utf-8';
        else throw TypeError('Illegal invocation');
      },
    });
  } catch (e) {
    // IE6-8 fallback
    (window as any).TextEncoder.prototype.encoding = 'utf-8';
  }
  if (typeof Symbol !== 'undefined')
    (window as any).TextEncoder.prototype[Symbol.toStringTag] = 'TextEncoder';
}
